function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
// eslint-disable-next-line no-restricted-imports
import { jsx } from 'panel';
import { VNode } from 'snabbdom';
import camelCase from 'lodash/camelCase';
import moment from 'moment';
import { LocalizationStore } from 'common/i18n/store';
import { UserIconEl } from 'common/widgets/user-icon';
import { IconSizeType } from 'common/constants';
import styles from './cell-renderer.module.styl';
type RenderCellLabelProps = {
  label: string;
  className: string;
};
export const RenderCellLabel = (_ref: RenderCellLabelProps): VNode => {
  let {
    label,
    className
  }: RenderCellLabelProps = _ref;
  return <span sel={".".concat(styles[camelCase(className)], ".").concat(className)} data-sentry-component="RenderCellLabel" data-sentry-source-file="cell-renderer.tsx">{label}</span>;
};
export const FormattedDateCell = (date: string, i18n: LocalizationStore): VNode => {
  const formattedDateValue = i18n.formatDate(moment(date), {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
  return <span data-sentry-component="FormattedDateCell" data-sentry-source-file="cell-renderer.tsx">{formattedDateValue}</span>;
};
type CreatorProps = {
  id: number;
  name: string;
  email: string;
};
export const CreatorCell = (user: CreatorProps): VNode => {
  return <div className={styles.creatorCell} data-sentry-component="CreatorCell" data-sentry-source-file="cell-renderer.tsx">
      <UserIconEl attrs={_objectSpread({
      size: IconSizeType.Medium,
      'include-label': true
    }, user)} data-sentry-element="UserIconEl" data-sentry-source-file="cell-renderer.tsx" />
    </div>;
};